import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import ProgressProvider from './ProgressProvider';
import { Link, useParams } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import useProps from '../hooks/useProps';

const Impact = () => {
    const { groupId } = useParams();
    usePageTitle('Measure Impact');
    const { props } = useProps();
    const axiosPrivate = useAxiosPrivate();
    const [loading, setLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const [generalStats, setGeneralStats] = useState([]);
    const [videoStats, setVideoStats] = useState(null);
    const [currentReport, setCurrentReport] = useState(null);
    const reports = [
        {
            id: 1,
            name: 'Combined Analytics',
            endPoint: groupId + '/analytics/invitations',
            aggregations: [
                {
                    label: props.speaker + ' Videos',
                    count: 'totalCreatedVideos'
                }, {
                    label: props.speaker + ' Videos Shared',
                    count: 'totalUniqueSharedVideosBySpeakers'
                }
            ]
        },
        {
            id: 2,
            name: 'Invitations Funnel',
            endPoint: groupId + '/analytics/private-invitation',
            aggregations: [
                {
                    label: 'Invitations Sent',
                    count: 'totalPrivateInvitations',
                    cta: {
                        text: 'View',
                        link: '/group/' + groupId + '/speakers?t=list'
                    }
                }, {
                    label: props.speaker + ' Recording Page Clicks',
                    count: 'viewedPrivateInvitationBySpeaker',
                    total: 'totalPrivateInvitations'
                }, {
                    label: props.speaker + ' Videos',
                    count: 'totalCreatedVideos',
                    total: 'totalPrivateInvitations'
                }, {
                    label: props.speaker + ' Videos Shared',
                    count: 'totalUniqueSharedVideosBySpeakers',
                    total: 'totalPrivateInvitations'
                }
            ]
        },
        {
            id: 3,
            name: 'Public Link',
            endPoint: groupId + '/analytics/public-invitation',
            aggregations: [
                {
                    label: 'Link Clicks',
                    count: 'publicInvitationsClickCount'
                }, {
                    label: props.speaker + ' Videos',
                    count: 'totalCreatedVideos',
                    total: 'publicInvitationsClickCount'
                }, {
                    label: props.speaker + ' Videos Shared',
                    count: 'totalUniqueSharedVideosBySpeakers',
                    total: 'publicInvitationsClickCount'
                }
            ]
        }
    ];
    const loadStats = async (reportId) => {
        const report = reports.find(s => s.id === reportId);
        if (!report) return;
        setCurrentReport(report.id);
        try {
            setLoading(true);
            const response = await axiosPrivate.get(report.endPoint);
            if (response?.data?.invitationActivity) {
                setReady(true);
                var invitationActivity = response.data.invitationActivity;
                var aggregations = [];
                report.aggregations.forEach((item) => {
                    var count = invitationActivity[item.count];
                    var aggregation = {
                        ...item,
                        count: count
                    };
                    if (item?.total && invitationActivity[item.total] > 0) {
                        aggregation.percent = Math.round((100 * count) / invitationActivity[item.total])
                    }
                    aggregations.push(aggregation);
                });
                setGeneralStats(aggregations);
            }
            if (response?.data?.videoStats) {
                setVideoStats(response.data.videoStats);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        loadStats(1);
    }, []);

    const Progress = (props) => {
        return (
            <div className="card border-0 bg-sp-light mb-3">
                <div className="card-body">
                    <div className='row'>
                        {!isNaN(props.percent) &&
                            <div className='col-4'>
                                <ProgressProvider valueStart={0} valueEnd={props.percent}>
                                    {value => <CircularProgressbar
                                        value={value}
                                        text={`${value}%`}
                                        strokeWidth='15'
                                        styles={{
                                            path: {
                                                stroke: '#FF7540',
                                            },
                                            text: {
                                                fill: '#005479',
                                                fontWeight: 'bold',
                                            }
                                        }
                                        }
                                    />}
                                </ProgressProvider>
                            </div>
                        }
                        <div className='col'>
                            {!isNaN(props.count) && !isNaN(props.percent) && <h5 className='text-primary'>{props.count}</h5>}
                            <div className='text-sp-dark'>
                                <strong>
                                    {props.text}
                                    {!isNaN(props.count) && isNaN(props.percent) && <span>: {props.count}</span>}
                                </strong>
                                {props.cta &&
                                    <Link to={props.cta.link} className='small float-end'>{props.cta.text}</Link>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    };

    const Stats = (attrs) => {
        return (
            <div className='d-flex flex-column h-100'>
                <div className="card border-0 mb-3 overflow-hidden  bg-sp-light flex-grow-1 d-flex flex-column">
                    <div className="table-stat-wrap flex-grow-1 overflow-auto position-relative">
                        <table className="table table-stat table-borderless position-absolute">
                            <thead>
                                <tr className='table-stat-head-sub'>
                                    <th width="100%" style={{ textTransform: 'uppercase' }}>{props.speaker}</th>
                                    <th>VIDEO</th>
                                    <th>VIEWS</th>
                                    <th className='text-nowrap'>CTA Clicks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attrs?.videos && attrs.videos.map((video, idx) =>
                                    <tr key={idx}>
                                        <td>{video.speakerName}</td>
                                        <td className='text-center'>
                                            <a href={video.videoURl} rel="noreferrer" target='_blank'>
                                                <FontAwesomeIcon icon={faExternalLinkAlt} />
                                            </a>
                                        </td>
                                        <td className='text-center'>
                                            <strong>{video.viewsCount}</strong>
                                        </td>
                                        <td className='text-center'>
                                            <strong>{video.ctaClicksCount}</strong>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className='text-center p-2 small d-none'>
                        <a href='#v'>View Full Report</a>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <section>
            <h4 className='mb-5'>Measure the impact of your promo videos</h4>
            <ul className="nav mb-3 nav-tabs">
                {reports.map((item) => (
                    <li className="nav-item me-2" key={item.id}>
                        <button className={`rounded-0 btn ${currentReport === item.id ? 'btn-primary' : 'btn-light'}`} type="button" onClick={(e) => {
                            if (currentReport !== item.id) {
                                loadStats(item.id);
                            }
                        }}>{item.name}</button>
                    </li>
                ))}
            </ul>
            <div className="tab-content">
                {loading ?
                    <div className="spinner-grow">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    :
                    ready ?
                        <div className="row">
                            {generalStats ?
                                <div className="col-sm-3" style={{ minHeight: '400px' }}>
                                    {generalStats.map((stat) => (
                                        <Progress key={stat.label} percent={stat.percent} count={stat.count} text={stat.label} cta={stat.cta}></Progress>
                                    ))}
                                </div>
                                : ''
                            }
                            <div className="col-sm-9">
                                <div className="h-100">
                                    {videoStats ?
                                        <Stats videos={videoStats}></Stats>
                                        : ''
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        <div className='alert alert-warning'>
                            <Link to={`/group/${groupId}/speakers`}>Click here</Link> to start inviting {props.speaker}s.
                        </div>
                }
            </div>
        </section>
    )
}

export default Impact
